import type { IconSvgObject } from './types';

const PerspectiveIcon: IconSvgObject = [
  ["path", { d: "M17.235 5.30188L6.23374 6.76859C5.24012 6.90106 4.49805 7.74864 4.49805 8.75105L4.49805 15.2489C4.49805 16.2514 5.24012 17.0989 6.23374 17.2314L17.235 18.6981C18.4339 18.858 19.4993 17.9252 19.4993 16.7157V7.28434C19.4993 6.07477 18.4339 5.14203 17.235 5.30188Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 22L12 2M2 12H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PerspectiveIcon;
